import { useRef } from 'react';
import { ApplicationTypeProductI } from '../../../../types/interface';
import { useDrag, useDrop } from 'react-dnd';
import { UilTrashAlt } from '@iconscout/react-unicons';

interface DragabbleProductItem {
  id: number;
  index: number;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  item: ApplicationTypeProductI;
  onDelete: (index: number) => void;
}
export const DraggableProductItem = ({
  id,
  index,
  moveItem,
  item,
  onDelete
}: DragabbleProductItem) => {
  const ref = useRef<HTMLTableRowElement | null>(null);

  const [{ isDragging }, drag] = useDrag({
    type: 'PRODUCT_ITEM',
    item: { id, index },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  const [, drop] = useDrop({
    accept: 'PRODUCT_ITEM',
    hover: (draggedItem: { index: number }, monitor) => {
      if (!ref.current) {
        return;
      }
      const dragIndex = draggedItem.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current.getBoundingClientRect();

      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      const clientOffset = monitor.getClientOffset();

      if (!clientOffset) {
        return;
      }

      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      moveItem(dragIndex, hoverIndex);

      draggedItem.index = hoverIndex;
    }
  });

  drag(drop(ref));

  return (
    <tr
      ref={ref}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
        backgroundColor: isDragging ? '#f0f0f0' : ''
      }}
    >
      <td>{index + 1}</td>
      <td>{item.name}</td>
      <td>
        <UilTrashAlt
          className="cursor-pointer"
          height={'15px'}
          width={'15px'}
          onClick={() => onDelete(index)}
        />
      </td>
    </tr>
  );
};
